// const ManageHome = () => import('@/components/Manage/manage.bot.template.vue')
const GeneralComponent = () => import('@/components/Manage/components/general.component.vue')
const EndPointComponent = () => import('@/components/Manage/components/endpoint.component.vue')
const CollaboratComponent = () => import('@/components/Manage/components/collaborators.component.vue')
const PublishComponent = () => import('@/components/Manage/components/publish.component.vue')
const VersionComponent = () => import('@/components/Manage/components/version.component.vue')

const ifAuthenticated = (to, from, next) => {
  if (!localStorage.token) {
    console.log('tets token in store', localStorage.token)
    next('/')
    return
  }
  next()
}

export default [
  {
    path: 'general',
    name: 'GeneralComponent',
    meta:{
      title: 'manage',
      subtitle: 'generalmanage'
    },
    component: GeneralComponent,
    beforeEnter: ifAuthenticated
  },{
    path: 'endpoint',
    name: 'EndPointComponent',
    meta:{
      title: 'manage',
      subtitle: 'manage'
    },
    component: EndPointComponent,
    beforeEnter: ifAuthenticated
  },{
    path: 'collaborator',
    name: 'CollaboratComponent',
    meta:{
      title: 'manage',
      subtitle: 'manage'
    },
    component: CollaboratComponent,
    beforeEnter: ifAuthenticated
  },{
    path: 'publish',
    name: 'PublishComponent',
    meta:{
      title: 'manage',
      subtitle: 'manage'
    },
    component: PublishComponent,
    beforeEnter: ifAuthenticated
  },{
    path: 'version',
    name: 'VersionComponent',
    meta:{
      title: 'manage',
      subtitle: 'manage'
    },
    component: VersionComponent,
    beforeEnter: ifAuthenticated
  },
]


// WEBPACK FOOTER //
// ./src/router/manage.router.js